import { FormSections1004, RulesBase1004, UiSections1004 } from './1004';
import { FormSections1073, RulesBase1073, UiSections1073 } from './1073';
import { FormSections1075, RulesBase1075, UiSections1075 } from './1075';
import { FormSections2055, RulesBase2055, UiSections2055 } from './2055';
import { FormSectionsFNMA, RulesBaseFNMA, UiSectionsFNMA } from './FNMA';
import { FormSectionsFREDDIE, RulesBaseFREDDIE, UiSectionsFREDDIE } from './FREDDIE';
import { FormSectionsIMSimpleInspection, RulesBaseIMSimpleInspection, UiSectionsIMSimpleInspection } from './IMSimpleInspection';

export const FormSections = {
	FORM1004: FormSections1004,
	FORM1073: FormSections1073,
	FORM1075: FormSections1075,
	FORM2055: FormSections2055,
	FNMA: FormSectionsFNMA,
	FREDDIE: FormSectionsFREDDIE,
	IMSimpleInspection: FormSectionsIMSimpleInspection
};

export const UiSections = {
	FORM1004: UiSections1004,
	FORM1073: UiSections1073,
	FORM1075: UiSections1075,
	FORM2055: UiSections2055,
	FNMA: UiSectionsFNMA,
	FREDDIE: UiSectionsFREDDIE,
	IMSimpleInspection: UiSectionsIMSimpleInspection
};

export const RulesBase = {
	FORM1004: RulesBase1004,
	FORM1073: RulesBase1073,
	FORM1075: RulesBase1075,
	FORM2055: RulesBase2055,
	FNMA: RulesBaseFNMA,
	FREDDIE: RulesBaseFREDDIE,
	IMSimpleInspection: RulesBaseIMSimpleInspection
};